import { Text } from '@clay-run/glaze/text';

/**
 * The loading state for the LinkedIn-enrichment side effect (auto-fire on QR
 * scan + the manual "Enrich with Clay" button, `ScanReview.tsx`). Rendered
 * inline inside the review form's `Card` — not a full-page modal — so the
 * rep can keep looking at (and editing) the rest of the form while a run is
 * in flight.
 *
 * First consumer of `/clay-logo-animation.gif` (repo-root `public/`, served
 * at `/clay-logo-animation.gif` in both dev and prod) outside of index.tsx —
 * kept local to lead-scanner rather than promoted to `_shared/components/`
 * until a second app needs it (`mini-apps/CLAUDE.md`'s promotion threshold).
 */
export default function EnrichingWithClay() {
  return (
    <div className="flex flex-col items-center gap-2 py-2">
      <img src="/clay-logo-animation.gif" alt="clay-logo" className="mx-auto h-auto w-24" />
      <Text size="sm" variant="tertiary">
        Enriching with Clay
      </Text>
    </div>
  );
}
